<template>
  <v-row no-gutters>
    <v-col v-if="appStore.isCustomer" class="delayEl">
      <CustomerAlert/>
    </v-col>
    <v-col v-else>
      <div
        id="cash-report-list"
        :class="{ 'page-fullscreen': pageStore.isFullScreen }"
      >
        <v-card
          tile
          :class="$vuetify.breakpoint.mdAndDown ? null : 'rounded-t-xl'"
        >
          <PageHeader>
            <template #action v-if="userData.role === 'SUBE'">
              <DataAddEdit @saveData="handleAddEdit" />
            </template>
          </PageHeader>

          <v-data-table
            :headers="tableColumns"
            :items="tableItems"
            :loading="tableLoading"
            :height="pageStore.tableHeight"
            loader-height="2"
            :mobile-breakpoint="100"
            fixed-header
            hide-default-footer
            :options.sync="tableOptions"
            :server-items-length="tableTotalRec"
            :disable-items-per-page="true"
            :items-per-page="20"
          >
            <!-- Load More -->
            <template v-slot:body.append v-if="loadMoreLoading">
              <tr>
                <td :colspan="tableColumns.length">
                  <div class="text-center" v-intersect.quiet="loadMore">
                    <v-progress-circular
                      v-if="tableItems.length > 0"
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </div>
                </td>
              </tr>
            </template>

            <!-- Arama Alanı -->
            <template v-slot:body.prepend>
              <tr class="data-table-body-search">
                <!-- ID -->
                <td class="pa-0">
                  <v-text-field
                    v-model="tableSearchID"
                    :prepend-inner-icon="icons.mdiMagnify"
                    persistent-placeholder
                    clearable
                    placeholder="Ara"
                    filled
                    class="rounded-0 elevation-0"
                    hide-details
                  />
                </td>

                <!-- Statu -->
                <td class="pa-0">
                  <div class="d-flex">
                    <v-select
                      v-model="tableSearchStatu"
                      :items="getCashStatusList"
                      :prepend-inner-icon="icons.mdiMagnify"
                      persistent-placeholder
                      clearable
                      placeholder="Ara"
                      filled
                      class="rounded-0 elevation-0"
                      hide-details
                    />
                  </div>
                </td>

                <!-- Hazırlayan -->
                <td class="pa-0">
                  <div class="d-flex">
                    <v-text-field
                      v-model="tableSearchUser"
                      :prepend-inner-icon="icons.mdiMagnify"
                      persistent-placeholder
                      clearable
                      placeholder="Ara"
                      filled
                      class="rounded-0 elevation-0"
                      hide-details
                    />
                  </div>
                </td>

                <!-- Sicil No
                <td class="pa-0">
                  <div class="d-flex">
                    <v-text-field
                      v-model="tableSearchUserNo"
                      :prepend-inner-icon="icons.mdiMagnify"
                      persistent-placeholder
                      clearable
                      placeholder="Ara"
                      filled
                      class="rounded-0 elevation-0"
                      hide-details
                    />
                  </div>
                </td>-->

                <!-- Form Tarihi -->
                <td class="pa-0">
                  <div class="d-flex">
                    <v-menu
                      v-model="tableSearchFormDateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="tableSearchFormDate"
                          :prepend-inner-icon="icons.mdiMagnify"
                          persistent-placeholder
                          clearable
                          placeholder="Ara"
                          filled
                          class="rounded-0 elevation-0"
                          hide-details
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="tableSearchFormDate"
                        @input="tableSearchFormDateMenu = false"
                        :max="new Date().toISOString().split('T')[0]"
                        no-title
                      >
                      </v-date-picker>
                    </v-menu>
                  </div>
                </td>

                <!-- Boş -->
                <td
                  class="pa-0"
                  v-for="item in tableEmptySearch"
                  :key="`emptySearch-${item}`"
                >
                  <v-text-field
                    filled
                    disabled
                    class="rounded-0 elevation-0"
                    hide-details
                  />
                </td>
              </tr>
            </template>

            <!-- ID -->
            <template #[`item.id`]="{ item }">
              <v-chip label color="chip" class="d-flex justify-center">
                <div
                  class="text-truncate text-uppercase data-table-item-type-one"
                  style="width: 39.9996px !important"
                >
                  {{ item.id }}
                </div>
              </v-chip>
            </template>

            <!-- Statu -->
            <template #[`item.statustxt`]="{ item }">
              <v-chip
                :color="item.statustype"
                class="d-flex justify-center text-caption"
                label
                outlined
              >
                {{ item.statustxt }}
              </v-chip>
            </template>

            <!-- Hazırlayan -->
            <template #[`item.hazirlayan_adsoyad`]="{ item }">
              <div class="white--text text-uppercase">
                {{ item.hazirlayan_adsoyad }}
              </div>
              <div class="text-caption">
                {{ item.name1 }}
              </div>
            </template>

            <!-- Form Tarihi -->
            <template #[`item.form_date`]="{ item }">
              <v-tooltip color="chip" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    {{ item.form_date | moment("DD.MM.YYYY ") }}
                  </div>
                </template>
                <div>
                  {{ item.form_date | moment("DD MMMM dddd") }}
                </div>
              </v-tooltip>
            </template>

            <!-- İşlem Tarihi -->
            <template #[`item.createdatetime`]="{ item }">
              <v-chip color="" class="d-flex justify-center" label>
                <div
                  class="text-truncate d-flex align-center data-table-item-type-one"
                  style="width: 149.9994px !important"
                >
                  <v-icon small class="mr-2">
                    {{ icons.mdiCalendarClock }}
                  </v-icon>
                  <div class="mr-1">
                    {{ item.createdatetime | moment("DD.MM.YYYY ") }}
                  </div>
                  <span> - {{ item.createdatetime | moment("HH:mm") }}</span>
                </div>
              </v-chip>
            </template>

            <!-- Hareket -->
            <template #[`item.actions`]="{ item }">
              <div class="d-flex justify-end">
                <v-tooltip
                  color="secondary"
                  bottom
                  v-if="item.status == 'FRST' && userData.role === 'SUBE'"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="store.openImageDialog(item.id)"
                      v-bind="attrs"
                      v-on="on"
                      small
                      outlined
                      min-width="10"
                    >
                      <v-icon size="18">{{ icons.mdiUpload }}</v-icon>
                    </v-btn>
                  </template>
                  <span>Görsel Yükle</span>
                </v-tooltip>
                <v-btn
                  v-if="item.status == 'FRST' && userData.role === 'SUBE'"
                  depressed
                  color="success"
                  @click="store.startProcessFn(item.id)"
                  small
                  class="mx-2"
                >
                  <div class="text-capitalize">Süreci Başlat</div>
                </v-btn>
                <DataView :data="item" />
              </div>
            </template>
          </v-data-table>
        </v-card>
      </div>
      <ImageAdd />
    </v-col>
  </v-row>
</template>

<script>
import { ref, watch, onMounted, onUnmounted } from "vue-demi";

// Pinia
import { useAppStore } from "@/stores/app";
import { usePageStore } from "@/stores/pageHeader";
import { useCashReportStore } from "./store";
import CustomerAlert from "@/components/CustomerAlert.vue";

// Utils
import { postData } from "@utils";
import { useDebounceFn } from "@vueuse/core";
import { useToast } from "vue-toastification/composition";

// Components
import PageHeader from "@/components/PageHeader/Index.vue";
import DataAddEdit from "./DataAddEdit.vue";
import DataView from "./DataView.vue";
import ImageAdd from "./ImageAdd.vue";

// Icons
import {
  mdiCashRegister,
  mdiMagnify,
  mdiCalendarClock,
  mdiUpload,
} from "@mdi/js";

export default {
  components: {
    PageHeader,
    DataAddEdit,
    DataView,
    ImageAdd,
    CustomerAlert,
  },
  setup() {
    const store = useCashReportStore();
    const appStore = useAppStore();
    const pageStore = usePageStore();
    const toast = useToast();
    const userData = JSON.parse(localStorage.getItem("userData"));

    const pageSettings = () => {
      pageStore.pageTitle = "Kasa Rapor";
      pageStore.pageIcon = mdiCashRegister;
      pageStore.hasFullScreen = false;
      pageStore.hasDownload = false;
      pageStore.hasDownloadApi = true;
      pageStore.hasDateRangeAll = true;
      pageStore.hasDateRange = true;
      pageStore.hasActions = true;
    };

    // Table
    const tableLoading = ref(true);
    const tableItems = ref([]);
    const tableTotalRec = ref(0);

    // Table Columns
    const tableColumns = ref([
      {
        text: "ID",
        value: "id",
        sortable: false,
        width: "90px",
      },

      {
        text: "Statu",
        value: "statustxt",
        sortable: false,
        width: "300.0006px",
      },

      {
        text: "Hazırlayan",
        value: "hazirlayan_adsoyad",
        sortable: false,
      },
      // {
      //   text: "Sicil No",
      //   value: "hazirlayan_sicilno",
      //   sortable: false,
      //   width: "149.9994px",
      // },
      {
        text: "Form Tarihi",
        value: "form_date",
        sortable: false,
        width: "129.9996px",
      },
      {
        text: "İşlem Tarihi",
        value: "createdatetime",
        align: "right",
        sortable: false,
        width: "149.9994px",
      },
      {
        text: "",
        value: "actions",
        sortable: false,
        width: "100.0008px",
      },
    ]);

    // Table Load More
    const tablePage = ref(1);
    const loadMoreLoading = ref(false);
    const loadMore = (isIntersecting) => {
      if (isIntersecting) {
        tablePage.value++;
        tableOptions.value.page = tablePage.value;
        if (!tableLoading.value) {
          tableFetch();
        }
      }
    };

    // Tablo Arama
    const tableReFetch = ref(false);
    const tableSearchID = ref("");
    const tableSearchCardNo = ref("");
    const tableSearchCustomer = ref("");
    const tableSearchStatu = ref("");
    const tableSearchUser = ref("");
    const tableSearchUserNo = ref("");

    const tableSearchFormDateMenu = ref(false);
    const tableSearchFormDate = ref("");

    const tableEmptySearch = ref(2);
    const tableOptions = ref({
      sortBy: ["id"],
      sortDesc: [true],
    });

    const debouncedTableSearch = useDebounceFn(() => {
      tableFetch();
    }, 700);

    watch(
      [
        tableSearchID,
        tableSearchCardNo,
        tableSearchCustomer,
        tableSearchStatu,
        tableSearchFormDate,
        tableReFetch,
        tableSearchUser,
        tableSearchUserNo,
      ],
      () => {
        loadMoreLoading.value = false;
        tableLoading.value = true;
        tablePage.value = 1;
        tableOptions.value.page = 1;
        tableItems.value = [];

        debouncedTableSearch();
      }
    );

    // Tarih aralığı için değişiklikler izleniyor
    const tableRangeDate = ref({
      start: null,
      end: null,
      text: null,
      value: "all",
    });
    watch(
      () => pageStore.dateRange,
      (newVal) => {
        tableRangeDate.value = newVal;
        loadMoreLoading.value = false;
        tableLoading.value = true;
        tablePage.value = 1;
        tableOptions.value.page = 1;
        tableItems.value = [];

        debouncedTableSearch();
      }
    );

    // API İstek
    const tableFetch = () => {
      if (appStore.isCustomer) {
        tableLoading.value = false;
        return;
      }
      tableLoading.value = true;
      const request = {
        method: "getCashForms",
        options: JSON.stringify(tableOptions.value),
      };

      if (tableRangeDate.value.value != "all") {
        request["search[t.startdate]"] = tableRangeDate.value.start;
        request["search[t.enddate]"] = tableRangeDate.value.end;
      }

      if (tableSearchID.value) {
        request["search[t.id]"] = tableSearchID.value;
      }
      if (tableSearchUser.value) {
        request["search[t.hazirlayan_adsoyad]"] = tableSearchUser.value;
      }
      if (tableSearchUserNo.value) {
        request["search[t.hazirlayan_sicilno]"] = tableSearchUserNo.value;
      }
      if (tableSearchStatu.value) {
        request["search[t.status]"] = tableSearchStatu.value;
      }
      if (tableSearchFormDate.value) {
        request["search[t.form_date]"] = tableSearchFormDate.value;
      }

      postData(request)
        .then((response) => {
          // API dönüşündeki hatalara bakıyoruz
          if (response.error) {
            throw new Error(response.msg);
          }

          // Toplam kayıt sayısı işleniyor
          tableTotalRec.value = Number(response.response.pagination.totalRec);

          // API'dan gelen veriler işleniyor

          // Responseda bir değer yoksa
          if (response.response.result.length === 0) {
            loadMoreLoading.value = false;
            return;
          }

          // Responsedan gelen veriler işleniyor
          response.response.result.map((item) => {
            tableItems.value.push({ ...item });
          });

          loadMoreLoading.value = false;
          if (tableTotalRec.value >= 20) {
            setTimeout(() => {
              loadMoreLoading.value = true;
            }, 300);
          }
          // Responstan gelen verilere göre loadmore değerlendiriliyor
        })
        .catch((e) => {
          // API hataya girdi
          toast.error(e.message, {
            position: "bottom-center",
          });
        })
        .finally(() => {
          // API işlemi bittikten sonra
          tableLoading.value = false;
          startPage.value = false;
        });
    };

    // Search Clear
    const searchClear = () => {
      tablePage.value = 1;
      tableOptions.value.page = 1;
      tableSearchID.value = null;
      tableReFetch.value = !tableReFetch.value;
    };

    // Add Edit Emit
    const handleAddEdit = (val) => {
      if (!val) return;

      searchClear();
    };
    const downloadForm = (file) => {
      console.log(file);
    };
    const sil = async (id) => {
      const request = {
        method: "deleteCashForm",
        id,
      };
      await postData(request);
      tableReFetch.value = !tableReFetch.value;
    };

    const getCashStatusList = ref([]);
    const cacheStatusGet = async () => {
      const request = {
        method: "getCashStatusList",
      };
      const { response, error, msg } = await postData(request);

      if (error) {
        return;
      }

      getCashStatusList.value = response.map((item) => {
        return {
          text: item.value,
          value: item.key,
        };
      });
    };

    const startPage = ref(false);
    onMounted(async () => {
      await cacheStatusGet();
      pageSettings();
      startPage.value = true;
      if (appStore.isCustomer) return;
      tableFetch();
    });

    onUnmounted(() => {
      pageStore.pageSettingsClear();
    });

    watch(
      () => [appStore.selectedCustomer],
      (val) => {
        if (appStore.isCustomer) return;
        // if (appStore.isCustomer) {
        //   return;
        // }
        if (!startPage.value) {
          loadMoreLoading.value = false;
          tableLoading.value = true;
          tablePage.value = 1;
          tableOptions.value.page = 1;
          tableItems.value = [];
          tableFetch();
        } else {
          startPage.value = false;
        }
      }
    );
    return {
      // Pinia
      store,
      pageStore,
      userData,
      appStore,

      // Table
      tableFetch,
      tableColumns,
      tableItems,
      tableLoading,
      loadMore,
      loadMoreLoading,
      tableTotalRec,
      tableEmptySearch,
      tableOptions,

      // Table Search
      tableSearchID,
      tableSearchCardNo,
      tableSearchCustomer,
      tableSearchStatu,
      tableSearchUser,
      tableSearchUserNo,
      tableSearchFormDateMenu,
      tableSearchFormDate,

      // Add Edit
      handleAddEdit,
      sil,

      // List
      getCashStatusList,
      downloadForm,

      // icons
      icons: {
        mdiCashRegister,
        mdiMagnify,
        mdiCalendarClock,
        mdiUpload,
      },
    };
  },
};
</script>
